const translationsLocations = {
  'de-DE': {
    cancelled: 'Abgesagt',
  },
  'de-AT': {
    cancelled: 'Abgesagt',
  },
  'de-CH': {
    cancelled: 'Abgesagt',
  },
  'pt-PT': {
    cancelled: 'Cancelado',
  },
  'en-GB': {
    cancelled: 'Cancelled',
  },
  es: {
    cancelled: 'Cancelado',
  },
  fr: {
    cancelled: 'Annullato',
  },
  it: {
    cancelled: 'Orari',
  },
  se: {
    cancelled: 'Avbokad',
  },
  nl: {
    cancelled: 'Geannuleerd',
  },
};

module.exports = translationsLocations;
